"use client";

import { c as _c } from "react/compiler-runtime";
import { IconUser } from "@tabler/icons-react";
import Link from "next/link";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { clearVerifyEmailBanner } from "@/lib/verifyEmailBanner";
interface Props {
  isLoggedIn: boolean;
}
const linkClass = "block rounded-sm px-2 py-1.5 text-sm no-underline! outline-hidden hover:bg-accent hover:opacity-100! focus-visible:bg-accent focus-visible:text-accent-foreground";
export function AccountMenu(t0) {
  const $ = _c(9);
  const {
    isLoggedIn
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpen(false);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const close = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PopoverTrigger asChild={true}><Button variant="ghost" size="icon" aria-label="Account"><IconUser className="size-5" /></Button></PopoverTrigger>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ul><li><Link href="/account/overview" className={linkClass} onClick={close}>My Account</Link></li><li><Link href="/account/orders" className={linkClass} onClick={close}>My Orders</Link></li></ul>;
    t4 = <hr className="-mx-1 my-1 h-px border-0 bg-border" />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== isLoggedIn) {
    t5 = <PopoverContent aria-label="Account" align="end" className="w-44 border-0 p-1"><nav aria-label="Account">{t3}{t4}<ul>{isLoggedIn ? <li><a href="/auth/logout" className={linkClass} onClick={() => {
              close();
              clearVerifyEmailBanner();
            }}>Log Out</a></li> : <li><a href="/auth/login" className={linkClass} onClick={close}>Log In</a></li>}</ul></nav></PopoverContent>;
    $[4] = isLoggedIn;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== open || $[7] !== t5) {
    t6 = <Popover open={open} onOpenChange={setOpen}>{t2}{t5}</Popover>;
    $[6] = open;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}